import React, { useRef, useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { Typography, Form, Input, Button, Row, Col, Select, message } from 'antd';
import { AlphaNumInput } from 'shared_components/pattern_input';

import { searchAgentsAPI } from 'services/agents/agents';
import { UserAccessContext } from 'context/userAccess';

const { Text } = Typography;
const { Option } = Select;

function SearchAgentForm({onFinish}) {
    const { userAccess } = useContext(UserAccessContext);
    const navigate = useHistory();
    const formRef = useRef();
    const [ loading, setLoading ] = useState(false);
    const [filterData, setFilterData] = useState([]);

    const createRight = userAccess['agents'].create;

    async function handleSubmit(formValues){
        // agent search api
        try {
            const result = await searchAgentsAPI(formValues)

            setFilterData(result);
            onFinish(result);
            
            if(result.length <= 0){
                message.info('No results found');
            }
        }catch(error) {
            console.log("error", error)
        }
    }

    function clearSearch(){
        // @ts-ignore
        const { setFieldsValue } = formRef.current;
        setFieldsValue({ agent_code: '', last_name: '', first_name: '', status: [] })
    }
    
    return (
        <div>
            <Form layout='vertical'
                onFinish={handleSubmit}
                ref={formRef}
            >
                {/* agent fields */}
                <Row gutter={[8, 1]} align='bottom'>
                    <Col span={4} className="gutter-row">
                        <Form.Item
                            label='AGENT CODE'
                            name="agent_code"
                        >
                            <Input placeholder='AGENT CODE' maxLength={50}/>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                        <div style={{ marginLeft:5 ,marginRight:10, marginBottom: 8 }}>
                            <Text strong className="inv-filler-str">OR</Text>
                        </div>
                    </Col>
                    <Col span={8} className="gutter-row">
                        <Form.Item
                            label='LAST NAME'
                            name="last_name"
                        >
                            <Input type='text' 
                                className='inv-input-uppercase'
                                placeholder='LAST NAME' 
                                maxLength={100}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8} className="gutter-row">
                        <Form.Item
                            label='FIRST NAME'
                            name="first_name"
                        >
                            <Input type='text' 
                                className='inv-input-uppercase'
                                placeholder='FIRST NAME'
                                maxLength={100}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={3} className="gutter-row">
                        <Form.Item
                            label='STATUS'
                            name="status"
                        >
                            <Select placeholder="STATUS"
                                showSearch	
                                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                            >
                                <Option value='ACTIVE'>ACTIVE</Option>
                                <Option value='INACTIVE'>INACTIVE</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                {/* buttons */}
                <Row gutter={[8, 1]} justify='end'>
                    <Col>
                        <Form.Item shouldUpdate>
                            {
                                ({ getFieldsValue }) => {
                                    const { agent_code, last_name, first_name, status } = getFieldsValue();
                                    const disabled = !( agent_code || last_name || first_name || status );

                                    return(
                                        <Row>
                                            <Button className="login-form-button inv-button"
                                            type="primary" 
                                            htmlType='submit'
                                            disabled={disabled}
                                            >
                                                SEARCH
                                            </Button>
                                            <Button className="form-button inv-button-right"
                                                onClick={clearSearch}
                                            >
                                                CLEAR
                                            </Button>
                                        </Row>
                                    )
                                }
                            }
                        </Form.Item>
                    </Col>
                </Row>
                {(createRight === 'TRUE')
                ?   <Row gutter={[8, 1]} justify='end' align='bottom'>
                        <Col className="gutter-row">
                            <Form.Item>
                                <Button 
                                    // className="login-form-button inv-button-right"
                                    style={{ marginBottom: -5}}
                                    type="primary" 
                                    onClick={() => navigate.push('/agent/add_agent')}
                                >
                                    ADD AGENT
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                :   <></>
                }
            </Form>
        </div>
    );
}

export default SearchAgentForm;